export default function slugify(string) {
  return string.trim().toLowerCase().replace(' ', '_');
};